import { CurrentPaymentInfo } from '@api';
import { fetchPaymentInfo } from '@redux/payment-info/payment-info.actions';
import { createReducer } from '@reduxjs/toolkit';


export const reducer = createReducer<CurrentPaymentInfo | null>(null, builder => builder
    .addCase(fetchPaymentInfo.fulfilled, (state, { payload }) => payload));
